import { useContext } from "react"
import GamepadContext from "../context/gamepad"

export default function useGamepad() {
    return useContext(GamepadContext)
}
